export const _setCboName = (state, action) => {
  state.cboName = action.payload;
};

export const _setOrganization = (state, action) => {
  state.organization = action.payload;
};

export const _setAcceptsCCCMS = (state, action) => {
  state.acceptsCCCMS = action.payload;
};

export const _setCbpCode = (state, action) => {
  state.cbpCode = action.payload;
};

export const _setFirstReferralContact = (state, action) => {
  state.firstReferralContact = action.payload;
};

export const _setSecondReferralContact = (state, action) => {
  state.secondReferralContact = action.payload;
};

export const _setLastVerWk = (state, action) => {
  state.lastVerWk = action.payload;
};

export const _setCup = (state, action) => {
  state.cup = action.payload;
};

export const _setModality = (state, action) => {
  state.modality = action.payload;
};

export const _setEnhancedServicesRate = (state, action) => {
  state.enhancedServicesRate = action.payload;
};

export const _setSTOPBeds = (state, action) => {
  state.sTOPBeds = action.payload;
};

export const _setVerificationContact = (state, action) => {
  state.verificationContact = action.payload;
};

export const _setVerificationContact2 = (state, action) => {
  state.verificationContact2 = action.payload;
};

export const _setSlecupNALtrDate = (state, action) => {
  state.slecupNALtrDate = action.payload;
};

export const _setCupMaxBeds = (state, action) => {
  state.cupMaxBeds = action.payload;
};

export const _setGender = (state, action) => {
  state.gender = action.payload;
};

export const _setGenderOldObject = (state, action) => {
  state.genderOldObject = action.payload;
};

export const _setGenderNewObject = (state, action) => {
  state.genderNewObject = action.payload;
};

export const _setBlanketPurchaseAgreementDedCapSap = (state, action) => {
  state.blanketPurchaseAgreementDedCapSap = action.payload;
};

export const _setMaxAdmits = (state, action) => {
  state.maxAdmits = action.payload;
};

export const _setWcVeificationContact1 = (state, action) => {
  state.wcVeificationContact1 = action.payload;
};

export const _setWcVeificationContact2 = (state, action) => {
  state.wcVeificationContact2 = action.payload;
};

export const _setADPEffDate = (state, action) => {
  state.aDPEffDate = action.payload;
};

export const _setADPLicCert = (state, action) => {
  state.aDPLicCert = action.payload;
};

export const _setAccepts290s = (state, action) => {
  state.accepts290s = action.payload;
};

export const _setFoodProvided = (state, action) => {
  state.foodProvided = action.payload;
};

export const _setCalOMSContact = (state, action) => {
  state.calOMSContact = action.payload;
};

export const _setWcCalOMSContacts1 = (state, action) => {
  state.wcCalOMSContacts1 = action.payload;
};

export const _setWcCalOMSContact2 = (state, action) => {
  state.wcCalOMSContact2 = action.payload;
};

export const _setADPExpDate = (state, action) => {
  state.aDPExpDate = action.payload;
};

export const _setADPMaxBeds = (state, action) => {
  state.ADPMaxBeds = action.payload;
};

export const _setDataDepartmentComment = (state, action) => {
  state.dataDepartmentComment = action.payload;
};

export const _setSap = (state, action) => {
  state.sap = action.payload;
};

export const _setBPADedCap = (state, action) => {
  state.bPADedCap = action.payload;
};

export const _setInactive = (state, action) => {
  state.inactive = action.payload;
};

export const _setFlagged = (state, action) => {
  state.flagged = action.payload;
};

export const _setVerLock = (state, action) => {
  state.verLock = action.payload;
};

export const _setCupNA = (state, action) => {
  state.cupNA = action.payload;
};

export const _setCurrentFYRateSheetReceivedandVerified = (state, action) => {
  state.currentFYRateSheetReceivedandVerified = action.payload;
};

export const _setOverorUnderDARSApprovedCountyRate = (state, action) => {
  state.overorUnderDARSApprovedCountyRate = action.payload;
};

export const _setContractComplianceStatusNote = (state, action) => {
  state.contractComplianceStatusNote = action.payload;
};

export const _setLowIntensity = (state, action) => {
  state.lowIntensity = action.payload;
};

export const _setMedIntensity = (state, action) => {
  state.medIntensity = action.payload;
};

export const _setHighIntensity = (state, action) => {
  state.highIntensity = action.payload;
};
